import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, Phone, X } from "lucide-react";
import { LOGO, PHONE } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";

const LINKS = [["Services", "/services"], ["About", "/about"], ["Gallery", "/gallery"], ["Contact", "/contact"]];

export const SiteHeader = ({ variant = "dark" }) => {
  const [open, setOpen] = useState(false);
  const { user, isStaff } = useAuth();
  const dark = variant === "dark";
  const base = dark ? "bg-[#020165]/80 border-white/10 text-white" : "bg-white/90 border-black/5 text-[#0D141A]";
  const accountHref = user ? (isStaff ? "/admin" : "/portal") : "/login";

  return (
    <header className={`relative z-30 h-16 flex items-center justify-between border backdrop-blur-md px-4 rounded-xl ${base}`}>
      <Link to="/" data-testid="nav-brand-logo" className="flex items-center gap-2.5 shrink-0">
        <img src={LOGO} alt="Accelary Motors" className="h-10 w-10 rounded-md bg-white object-contain p-0.5" />
        <span className="font-display font-extrabold tracking-tight text-lg leading-none">
          Accelary<span className="text-[#F86900]"> Motors</span>
        </span>
      </Link>
      <nav className="hidden lg:flex items-center gap-7 text-sm font-medium">
        {LINKS.map(([l, h]) => (
          <NavLink key={h} to={h} data-testid={`nav-link-${l.toLowerCase()}`}
            className={({ isActive }) => `transition-colors hover:text-[#F86900] ${isActive ? "text-[#F86900]" : ""}`}>
            {l}
          </NavLink>
        ))}
        <Link to="/roadside" data-testid="nav-roadside-help-button"
          className="flex items-center gap-1.5 text-[#F86900] hover:opacity-80 transition-opacity">
          <Phone className="h-4 w-4" /> Roadside Help
        </Link>
      </nav>
      <div className="hidden lg:flex items-center gap-3">
        <Link to={accountHref} data-testid="nav-client-login-button"
          className={`px-4 py-2 rounded-full text-sm font-semibold border transition-colors ${dark ? "border-white/25 hover:bg-white/10" : "border-[#020165]/20 hover:bg-[#020165]/5"}`}>
          {user ? (isStaff ? "Workshop Console" : "My Portal") : "Client Login"}
        </Link>
        <Link to="/quote" data-testid="nav-get-quote-button"
          className="px-5 py-2 rounded-full text-sm font-bold bg-[#F86900] text-[#0D141A] hover:bg-[#ff7d1f] transition-colors">
          Get a Quote
        </Link>
      </div>
      <button className="lg:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-menu-button" aria-label="Menu">
        {open ? <X /> : <Menu />}
      </button>
      {open && (
        <div className="absolute top-[4.5rem] left-0 right-0 rounded-xl bg-[#020165] text-white p-5 flex flex-col gap-4 shadow-2xl lg:hidden" data-testid="nav-mobile-menu">
          {LINKS.map(([l, h]) => (
            <Link key={h} to={h} onClick={() => setOpen(false)} className="font-medium" data-testid={`nav-mobile-link-${l.toLowerCase()}`}>{l}</Link>
          ))}
          <Link to="/roadside" onClick={() => setOpen(false)} className="text-[#F86900] font-semibold">Roadside Help</Link>
          <a href={`tel:${PHONE}`} className="text-white/70 text-sm">{PHONE}</a>
          <div className="flex gap-3 pt-2">
            <Link to={accountHref} className="flex-1 text-center px-4 py-2.5 rounded-full border border-white/25 text-sm font-semibold">
              {user ? "My Account" : "Client Login"}
            </Link>
            <Link to="/quote" className="flex-1 text-center px-4 py-2.5 rounded-full bg-[#F86900] text-[#0D141A] text-sm font-bold">Get a Quote</Link>
          </div>
        </div>
      )}
    </header>
  );
};
